(ns common.schema.entities.decision-pm-approval
  "PM (Portfolio Manager) approval decision, used by the CapMan
   transaction-process templates. PM approval keeps the Details / Conditions /
   Reservations / Notes sections, so this schema reuses the base decision fields
   plus investment reservations, conditions and notes. It deliberately omits the
   IC-specific capacity / strategy-compliance / IC-approval fields.

   All attributes are existing `:decision/*` idents (also used by the IC
   decision), so adding this entity type needs no migration — entity types are
   keyword values of `:entity/type`, not Datomic idents."
  (:require
   [common.schema.schema-utils :as su]
   [common.schema.entities.decision :as decision]))

(def schema
  (concat
   decision/schema

   (su/multi-ref-field :decision/investment-reservations
                       "Investment reservations"
                       [:entity.type/investment-reservation]
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use})

   (su/multi-ref-field :decision/conditions
                       "Conditions"
                       [:entity.type/decision-condition]
                       {:authorization            su/access-user-user
                        :default-field-visibility :in-use})

   (su/text-multiline-field :decision/notes
                            "Notes"
                            {:authorization            su/access-user-user
                             :default-field-visibility :in-use})))

(def required-fields
  #{:decision/date})
